import React from 'react';
import AppApi from "../../../api/app";
import toast from 'react-hot-toast';
import gallery from "../../../api/gallery";
import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik } from "formik";
import Actions from '../../../store/actions';
import { useDispatch } from 'react-redux';


let validationSchema = Yup.object({
   pixelId: Yup.string().required("pixel ID is required."),
   status: Yup.boolean().oneOf([true, false], "Status must be a boolean value.").required("Status is required."),
});

function TiktokPixel({ setPluginModel, data }) {
   const dispatch = useDispatch();

   return (
      <>
         <Formik
            initialValues={{
               pixelId: data?.pixelId || "",
               status: data?.status !== undefined ? data.status : true,
            }}
            validationSchema={validationSchema}
            onSubmit={async (values, { setSubmitting, resetForm }) => {
               setSubmitting(true);
               try {
                  let res = await AppApi.tiktokPixel(values);
                  if (res?.data?.error == false) {
                     toast.success(res?.data?.msg);
                     dispatch(Actions.updatePlugin({ tiktokPixel: res?.data?.data }));
                  }
                  resetForm();
                  setSubmitting(false);
                  setPluginModel(false);
               } catch (error) {
                  console.log(error.message);
                  setSubmitting(false);
               }
            }}
         >
            {({ isSubmitting, values, errors, setFieldValue }) => (
               <Form>
                  <div className=" form mt-1">
                     <div className="form-group flex-grow-1">
                        <label>pixel ID</label>
                        <Field
                           name="pixelId"
                           type="text"
                           className="form-control rounded"
                           placeholder="pixel ID"
                        />
                        <ErrorMessage component="small" className='text-danger' name="pixelId" />
                     </div>
                  </div>
                  <div className="form-check mt-2">
                     <Field name="status" className="form-check-input" type="checkbox" id="status" />
                     <label className="form-check-label" htmlFor="status">
                        Status
                     </label>
                  </div>
                  <div className="p-0 mt-2 text-left col-sm-12">
                     <div className="mb-1 d-flex justify-content-end form-group">
                        <button type="submit" disabled={isSubmitting} className="btn rounded-0 btn-dark">{isSubmitting ? "Loading..." : "Save"}</button>
                     </div>
                  </div>
               </Form>
            )}
         </Formik>
         <hr />
         <div className="documentation mt-4">
            <h5>How to Obtain Your Google Search Content ID</h5>
            <p>To integrate Google Search with your application, you need to obtain the Content ID. Follow these steps:</p>
            <ol>
               <li>
                  <strong>Log in to Google Search Console:</strong> Visit the <a href="https://search.google.com/search-console" target="_blank" rel="noopener noreferrer" className='text-primary'>Google Search Console website</a> and log in with your credentials.
               </li>
               <li>
                  <strong>Add a Property:</strong> If you haven't already, add your website as a property by clicking on the "Add Property" button and following the instructions.
               </li>
               <li>
                  <strong>Verify Your Property:</strong> Follow the verification steps provided by Google to verify ownership of your website.
               </li>
               <li>
                  <strong>Access the Settings:</strong> Once your property is verified, navigate to the settings by clicking on the gear icon or the settings link in the sidebar.
               </li>
               <li>
                  <strong>Find Your Content ID:</strong> In the settings, look for the section related to your site's information. Your Content ID will be listed there, typically as a unique identifier.
               </li>
            </ol>
            <p>Once you have your Content ID, enter it in the respective field above to complete the integration with Google Search.</p>
         </div>
         <br />
         <br />
      </>
   )
}

export default TiktokPixel



